import { isObject } from '@atlassiansox/bxp-shared-utils';
import { isAttachment } from './attachment';
import { isBlendMode } from './blend-mode';
import { isBreakpoint } from './breakpoint';
import { isClip } from './clip';
import { isImage } from './image';
import { isOrigin } from './origin';
import { isPosition } from './position';
import { isRepeat } from './repeat';
import { isSize } from './size';
export function isProperties(value) {
    if (!isObject(value)) {
        return false;
    }
    const temp = value;
    return (isAttachment(temp.attachment) &&
        isBlendMode(temp.blendMode) &&
        isClip(temp.clip) &&
        isImage(temp.image) &&
        isOrigin(temp.origin) &&
        isPosition(temp.position) &&
        isRepeat(temp.repeat) &&
        isSize(temp.size));
}
export function isBackgroundField(value) {
    if (!isObject(value)) {
        return false;
    }
    const temp = value;
    return (Array.isArray(temp.breakpoints) &&
        temp.breakpoints.every((breakpoint) => isBreakpoint(breakpoint)) &&
        typeof temp.color === 'string' &&
        Array.isArray(temp.properties) &&
        temp.properties.every((property) => isProperties(property)));
}
export function isBackgroundFieldArray(value) {
    if (!Array.isArray(value) || value.length < 1) {
        return false;
    }
    return value.every((item) => isBackgroundField(item));
}
//# sourceMappingURL=background-field.js.map